import {FC} from 'react'
import {promptInstall} from '../core/installPrompt'
import {installedAppName, useInstallState} from '../core/useInstallState'
import {InstallAppModal} from './InstallAppModal'

/** The install guide with this device's state; the sign-in page and the panel layout show it. */
export const InstallGuideDialog: FC<{show: boolean; onClose: () => void}> = ({show, onClose}) => {
  const {prompt, detected, runningInstalled, installedElsewhere} = useInstallState()
  return (
    <InstallAppModal
      show={show}
      appName={installedAppName()}
      detected={detected}
      canPrompt={prompt.canPrompt}
      runningInstalled={runningInstalled}
      installedNow={prompt.installedNow}
      installedElsewhere={installedElsewhere}
      onPrompt={promptInstall}
      onClose={onClose}
    />
  )
}
